import { AnimateUniDriver } from '../Animate/Animate.uni.driver';

export interface BounceAnimationUniDriver extends AnimateUniDriver {}
